import React, { Component } from "react";
import {
  profile,
  loading,
  NavbarCustomer,
  t // นำเข้าฟังก์ชันแปลภาษา
} from "../../components/CustomComponent.js"; 

export default class CustomerDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Mock Data: Summary Stats
      stats: {
        open_requests: 3,
        in_progress: 2,
        scheduled_visits: 1,
        total_assets: 12
      },

      // Mock Data: Active Jobs
      active_jobs: [
        {
          id: "WO-20250110-0023",
          title: "Compressor Unit Inspection",
          titleKey: "job_title_inspection", // เพิ่ม Key สำหรับแปล
          asset: "Chiller Unit #3",
          tech: "Somchai T.",
          status: "Technician En-route",
          statusKey: "status_enroute",
          statusColor: "warning",
          detail: "ETA: 15 minutes",
          detailKey: "eta_15_min",
          detailIcon: "\uf017",
          icon: "\uf0d1",
          bg: "bg-warning-light text-warning"
        },
        {
          id: "WO-20250110-0018",
          title: "HVAC Filter Replacement",
          titleKey: "job_title_filter",
          asset: "AHU Unit - Floor 2",
          tech: "Prasit K.",
          status: "Technician On-site",
          statusKey: "status_onsite",
          statusColor: "success",
          detail: "In Progress",
          detailKey: "in_progress",
          detailIcon: "\uf0ad",
          icon: "\uf0ad",
          bg: "bg-success-light text-success"
        },
        {
          id: "WO-20250110-0025",
          title: "Generator Quarterly PM",
          titleKey: "job_title_pm",
          asset: "Generator Set - Building A",
          tech: "Wichai S.",
          status: "Scheduled",
          statusKey: "status_scheduled",
          statusColor: "primary",
          detail: "Tomorrow, 09:00",
          detailKey: "tomorrow_0900",
          detailIcon: "\uf073",
          icon: "\uf11d",
          bg: "bg-primary-light text-primary"
        }
      ],

      upcoming_visits: [
        { day: "11", month: "jan", titleKey: "job_title_pm_service", time: "09:00 - 12:00", tech: "Wichai S.", initials: "WS" },
        { day: "15", month: "jan", titleKey: "job_title_chiller_insp", time: "14:00 - 16:00", tech: "Somchai T.", initials: "ST" }
      ],

      recent_reports: [
        { id: "WO-20250108-0012", titleKey: "pump_repair", date: "Jan 8, 2025" },
        { id: "WO-20250105-0008", titleKey: "valve_replacement", date: "Jan 5, 2025" }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  render() {
    const { stats, active_jobs, upcoming_visits, recent_reports } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        
        <div className="body p-4 mt-3">
          {/* Header Banner Section */}
          <div className="bg-success text-white p-4 rounded-4 shadow-sm mb-4 d-flex justify-content-between align-items-center" style={{ background: "linear-gradient(90deg, #198754 0%, #20c997 100%)" }}>
            <div>
              <h3 className="fw-bold mb-1">{t("greeting")}, {profile?.company_name || "ABC Manufacturing"}</h3>
              <div className="text-white text-opacity-75">{t("today_date_display")}</div>
            </div>
            <button className="btn btn-light fw-bold px-4 py-2 rounded-3 shadow-sm border-0 text-success d-flex align-items-center">
              <span className="me-2 text-20">+</span> {t("create_service_request")}
            </button>
          </div>

          {/* Top KPI Stats */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-14 fw-bold">{t("open_requests")}</div>
                    <h2 className="fw-bold mb-0 mt-1">{stats.open_requests}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf15b"}</div>
                </div>
              </div>
            </div>
            {/* ... ตัวอย่าง KPI อื่นๆ ใช้โครงสร้างเดียวกัน ... */}
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-14 fw-bold">{t("in_progress")}</div>
                    <h2 className="fw-bold text-warning mb-0 mt-1">{stats.in_progress}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf0ad"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-14 fw-bold">{t("scheduled_visits")}</div>
                    <h2 className="fw-bold text-success mb-0 mt-1">{stats.scheduled_visits}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf073"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-14 fw-bold">{t("total_assets")}</div>
                    <h2 className="fw-bold mb-0 mt-1">{stats.total_assets}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf1b3"}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-lg-8">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-0 d-flex align-items-center"><span className="icon text-primary me-2">{"\uf0ca"}</span> {t("active_jobs")}</h5>
                <a href="#" className="text-decoration-none text-14 fw-bold">{t("view_all")}</a>
              </div>
              
              <div className="d-flex flex-column gap-3 mb-5">
                {active_jobs.map((job, idx) => (
                  <div key={idx} className="card border-0 rounded-4 shadow-sm p-3 bg-white transition-hover">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="d-flex">
                        <div className={`wpx-40 hpx-40 rounded d-flex align-items-center justify-content-center icon text-18 me-3 ${job.bg}`}>{job.icon}</div>
                        <div>
                          <div className="text-secondary text-12 mb-1">{job.id}</div>
                          <h6 className="fw-bold text-dark mb-1">{t(job.titleKey)}</h6>
                          <div className="text-secondary text-12 mb-2">{job.asset}</div>
                          <div className="d-flex align-items-center gap-3">
                            <div className="text-dark text-12 fw-bold"><span className="icon me-1">{"\uf007"}</span> {job.tech}</div>
                            <div className={`text-12 fw-bold text-${job.statusColor}`}><span className="icon me-1">{job.detailIcon}</span> {t(job.detailKey)}</div>
                          </div>
                        </div>
                      </div>
                      <span className={`badge bg-${job.statusColor}-light text-${job.statusColor} rounded-pill px-3 py-1 text-10 border border-${job.statusColor} border-opacity-10`}>
                         <span className="icon me-1">{"\uf0d1"}</span> {t(job.statusKey)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-bold mb-0 d-flex align-items-center"><span className="icon text-primary me-2">{"\uf15c"}</span> {t("recent_service_reports")}</h5>
                <a href="#" className="text-decoration-none text-14 fw-bold">{t("view_all")}</a>
              </div>
              <div className="card border-0 rounded-4 shadow-sm bg-white overflow-hidden">
                {recent_reports.map((report, idx) => (
                  <div key={idx} className={`p-3 d-flex justify-content-between align-items-center ${idx !== recent_reports.length - 1 ? 'border-bottom' : ''}`}>
                    <div className="d-flex align-items-center">
                      <div className="wpx-40 hpx-40 rounded bg-danger-light text-danger d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf1c1"}</div>
                      <div>
                        <h6 className="fw-bold text-dark mb-0">{report.id} - {t(report.titleKey)}</h6>
                        <div className="text-secondary text-12">{t("completed")}: {report.date}</div>
                      </div>
                    </div>
                    <button className="btn btn-outline-secondary btn-sm px-3 rounded-2 text-dark border-light fw-bold bg-white d-flex align-items-center shadow-sm">
                      <span className="icon me-2">{"\uf019"}</span> {t("download")}
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-4">
              <h5 className="fw-bold mb-3 d-flex align-items-center"><span className="icon text-primary me-2">{"\uf073"}</span> {t("upcoming_visits")}</h5>
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white mb-4">
                <div className="d-flex flex-column gap-4">
                  {upcoming_visits.map((visit, idx) => (
                    <div key={idx} className="d-flex">
                      <div className="text-center me-3">
                        <div className="bg-success text-white rounded-3 overflow-hidden shadow-sm" style={{ width: '45px' }}>
                          <div className="text-10 py-1" style={{ backgroundColor: '#157347' }}>{t(visit.month)}</div>
                          <div className="fw-bold py-1 bg-success-light text-success">{visit.day}</div>
                        </div>
                      </div>
                      <div>
                        <h6 className="fw-bold text-dark mb-1">{t(visit.titleKey)}</h6>
                        <div className="text-secondary text-12 mb-2">{visit.time}</div>
                        <div className="d-flex align-items-center">
                          <div className="wpx-20 hpx-20 rounded-circle bg-primary text-white d-flex align-items-center justify-content-center text-8 fw-bold me-2">{visit.initials}</div>
                          <div className="text-secondary text-12">{visit.tech}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <hr className="my-4 text-light" />
                <div className="text-center">
                  <a href="#" className="text-decoration-none text-14 fw-bold">{t("view_full_calendar")}</a>
                </div>
              </div>

              <h5 className="fw-bold mb-3 d-flex align-items-center"><span className="icon text-primary me-2">{"\uf0e7"}</span> {t("quick_actions")}</h5>
              <div className="d-flex flex-column gap-2 mb-4">
                <button className="btn btn-white bg-white border-0 shadow-sm rounded-4 p-3 d-flex align-items-center text-start transition-hover">
                  <div className="wpx-35 hpx-35 rounded bg-success-light text-success d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf067"}</div>
                  <span className="fw-bold text-dark text-14">{t("new_service_request")}</span>
                </button>
                <button className="btn btn-white bg-white border-0 shadow-sm rounded-4 p-3 d-flex align-items-center text-start transition-hover">
                  <div className="wpx-35 hpx-35 rounded bg-purple-light text-purple d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf1b3"}</div>
                  <span className="fw-bold text-dark text-14">{t("view_my_assets")}</span>
                </button>
                <button className="btn btn-white bg-white border-0 shadow-sm rounded-4 p-3 d-flex align-items-center text-start transition-hover">
                  <div className="wpx-35 hpx-35 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf1da"}</div>
                  <span className="fw-bold text-dark text-14">{t("service_history")}</span>
                </button>
                <button className="btn btn-white bg-white border-0 shadow-sm rounded-4 p-3 d-flex align-items-center text-start transition-hover">
                  <div className="wpx-35 hpx-35 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center icon text-18 me-3">{"\uf095"}</div>
                  <span className="fw-bold text-dark text-14">{t("contact_support")}</span>
                </button>
              </div>

              <div className="card border-0 rounded-4 p-3 shadow-sm" style={{ backgroundColor: '#fffbeb', border: '1px solid #fde68a !important' }}>
                <div className="d-flex align-items-start">
                  <span className="icon text-warning me-2 text-18">{"\uf071"}</span>
                  <div>
                    <h6 className="fw-bold text-dark mb-1 text-14">{t("warranty_expiring")}</h6>
                    <div className="text-secondary text-12 mb-2">{t("warranty_alert_msg")}</div>
                    <a href="#" className="text-warning text-decoration-none fw-bold text-12">{t("view_details")}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}